"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.YAMLReader = exports.JSONReader = exports.ObjectReader = exports.XMLReader = void 0;
var XMLReader_1 = require("./XMLReader");
Object.defineProperty(exports, "XMLReader", { enumerable: true, get: function () { return XMLReader_1.XMLReader; } });
var ObjectReader_1 = require("./ObjectReader");
Object.defineProperty(exports, "ObjectReader", { enumerable: true, get: function () { return ObjectReader_1.ObjectReader; } });
var JSONReader_1 = require("./JSONReader");
Object.defineProperty(exports, "JSONReader", { enumerable: true, get: function () { return JSONReader_1.JSONReader; } });
var YAMLReader_1 = require("./YAMLReader");
Object.defineProperty(exports, "YAMLReader", { enumerable: true, get: function () { return YAMLReader_1.YAMLReader; } });
//# sourceMappingURL=index.js.map